// ComingSoon------------------------------------------------------
import ComingSoon from 'pages/ComingSoon';

// Home------------------------------------------------------
import UserHome from 'pages/Home';

// Export------------------------------------------------------
import Exchange from 'pages/Exchange';

// SerialNumber------------------------------------------------------
import SerialNumber from 'pages/SerialNumber';

// Giveaway------------------------------------------------------
import Giveaway from 'pages/Giveaway';

// Award------------------------------------------------------
import Award from 'pages/Award';

// Activity------------------------------------------------------
import Activity from 'pages/Activity';

// WhereToBuy------------------------------------------------------
import WhereToBuy from 'pages/WhereToBuy';

const routes = [
    {
        path: '/',
        exact: true,
        component: UserHome,
    },
    {
        path: '/coming-soon',
        exact: true,
        auth: false,
        component: ComingSoon,
    },
    {
        path: '/exchange',
        exact: true,
        auth: true,
        component: Exchange,
    },
    {
        path: '/serial-number',
        exact: true,
        auth: true,
        component: SerialNumber,
    },
    {
        path: '/giveaway',
        exact: true,
        auth: true,
        component: Giveaway,
    },
    {
        path: '/award',
        exact: true,
        auth: false,
        component: Award,
    },
    {
        path: '/activity',
        exact: true,
        auth: false,
        component: Activity,
    },
    {
        path: '/where-to-buy',
        exact: true,
        auth: false,
        component: WhereToBuy,
    },
];

export default routes;